export const HEADERS = {
  ACCEPT_LANGUAGE: 'accept-language',
  COOKIE: 'cookie',
  CSRF_TOKEN: 'x-csrftoken',
  ENCODING: 'accept-encoding',
  EXTRACTION_SOURCE_OF_TRUTH: 'X-Extraction-Source-Of-Truth',
  FORWARDED_HOST: 'x-forwarded-host',
  FORWARDED_PROTO: 'x-forwarded-proto',
  GEOIP_CF_CITY: 'cf-ipcity',
  GEOIP_CF_COUNTRY: 'cf-ipcountry',
  GEOIP_CF_LATITUDE: 'cf-iplatitude',
  GEOIP_CF_LONGITUDE: 'cf-iplongitude',
  HOST: 'host',
  IDENTIFICATION_REQUEST_ID: 'x-request-id',
  IDENTIFICATION_VISITOR_ID: 'x-visitor-id',
  MARKET_COUNTRY_CODE: 'bm-market',
  NGINX_IP: 'x-forwarded-for',
  USER_AGENT: 'user-agent',
  VERIFIED_BOT: 'x-bm-bopip-verified-bot',
  AMPLITUDE_DEVICE_ID: 'bm-amplitude-device-id',
  AMPLITUDE_SESSION_ID: 'bm-amplitude-session-id',
  APP_PLATFORM: 'app-platform',
} as const

/**
 * Path prefixes for auth endpoints served by the accounts/identity backend
 * (accounts.* subdomain). Requests to these endpoints are cross-origin from
 * the front-office app, so custom headers like X-Extraction-Source-Of-Truth
 * must not be added to avoid CORS preflight failures.
 */
export const AUTH_PATH_PREFIXES = ['/oauth2/', '/auth/'] as const

/**
 * The following is linked to the bot challenge management handled by BOPIP.
 * If you want more details about this, please refer to their documentation.
 */
export const BOT_CHALLENGE = {
  TYPE: 'bot-need-challenge',
  MESSAGE: 'BOT_NEED_CHALLENGE error received during server side rendering',
  REDIRECT: '/testchallengepage',
}

/**
 * Event name dispatched when a 401 response is received on the client side.
 * Applications can listen to this event to show a session expired modal.
 */
export const UNAUTHENTICATED_CLIENT_FETCH_EVENT =
  'unauthenticated-client-fetch-call'
